module.exports = __webpack_public_path__ + "fonts/Artifakt-Element-Bold.98349b85.woff";